import React, { FC } from "react";

import CampaignBuilderForm from "../../components/redesign/modules/CampaignBuilderForm";
import { CAMPAIGN_PLAY_TYPE } from "../../constants/campaignPlayTypes";
import { CAMPAIGN_STEPS } from "../../types/campaignTypes";

const ContextualPersonaCreatePageRedesign: FC = () => (
  <CampaignBuilderForm
    mode="campaign"
    campaignPlayType={CAMPAIGN_PLAY_TYPE.CONTEXTUAL_PERSONA}
    visibleOptionalPanels={[CAMPAIGN_STEPS.ROLE_TITLES, CAMPAIGN_STEPS.PUBLICATION_LISTS]}
  />
);

export default ContextualPersonaCreatePageRedesign;
